import { useState } from 'react';
import CollapseContext from '../context/collapse-context';

const Collapse = (props) => {
    const { children, defaultExpanded } = props;

    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <CollapseContext.Provider value={{ expanded, setExpanded }}>
            {typeof children === 'function' ? children({ expanded, setExpanded }) : children}
        </CollapseContext.Provider>
    );
};

Collapse.defaultProps = {
    defaultExpanded: false,
};

export default Collapse;
